module.exports = __webpack_public_path__ + "cb40c9b8cb4576ff43176dd912330d7e.svg";